import { createUseStyles } from 'react-jss'

import { colors } from '../colors'

const useStatusBadgeStyles = createUseStyles(() => ({
  statusBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  dot: {
    display: 'block',
    height: '12px',
    width: '12px',
    borderRadius: '100%',

    '&.success': {
      backgroundColor: colors.theme500
    },

    '&.danger': {
      backgroundColor: colors.red500
    },

    '&.warning': {
      backgroundColor: colors.orange500
    }
  }
}))

export { useStatusBadgeStyles }
